export default "__VITE_ASSET__3es7bfsQ__"